<template>
    <section class="px-content py-20 xl:py-[120px] will-change" :data-scroll-section="inner == 'false'">
        <div class="flex flex-col items-center text-center mb-[72px]" data-scroll data-scroll-class="xyz-in" xyz="fade down duration-15">
            <h2 class="text-4xl xl:text-heading mb-8" v-show="blockData.title">{{ blockData.title }}</h2>
            <div class="block-text xl:max-w-[40vw] leading-normal" v-show="blockData.text" v-html="blockData.text"></div>
        </div>

        <!-- tabs -->
        <div class="tabs py-2" v-show="blockData.tabs">
            <ul class="tabs__nav ">
                <li class="flex flex-col text-lg xl:text-xl leading-snug px-6 xl:px-16"
                    :class="{'active text-navy-blue-01' : activeTab === tab, 'text-navy-blue-03' : activeTab !== tab}"
                    v-for="(tab, index) in blockData.tabs"
                    :key="index+tab.title"
                    @click="activeTab = tab"
                >
                    <div class="cursor-pointer">{{ tab.title }}</div>
                </li>
            </ul>
            <!-- <div v-show="blockData.tabs" v-for="(tab, index) in blockData.tabs" :key="index+tab.title" @click="activeTab = tab" :class="{'active-tab' : activeTab === tab}"> {{ tab.title }} </div> -->

            <!-- tab content -->
            <div class="pt-16 flex justify-center items-baseline">

                <XyzTransitionGroup appear-visible class="flex flex-col items-center justify-between md:justify-center mx-4 xl:mx-16 md:w-[20%] xl:w-[10%]" v-for="(item, index) in activeTab.items" :key="index+item.smaller_text" xyz="fade small">
                    <div class="flex items-center justify-center w-16 h-16 xl:w-20 xl:h-20 border rounded-full border-light-blue-01 mb-4" :key="index">
                        <img v-if="item.icon" :src="item.icon.url" :alt="item.icon.alt">
                    </div>

                    <div class="text-sm text-navy-blue-03 text-center mb-1" v-if="item.smaller_text" :key="index+item.smaller_text">{{ item.smaller_text }}</div>
                    <div class="text-lg xl:text-xl text-center text-navy-blue-01 leading-snug font-canela" v-if="item.bigger_text" :key="index+item.bigger_text">{{ item.bigger_text }}</div>

                </XyzTransitionGroup>
            </div>
            <!-- ./tab content -->

        </div>
        <!-- ./tabs -->

        <!-- Disclaimer -->
        <div class="text-mid-grey text-base text-center my-8" v-if="blockData.font_color" v-html="blockData.font_color"></div>
        <!-- ./Disclaimer -->

    </section>
</template>


<script>
    export default {
        name: 'TextSwitchingTabsIcons',
        data() {
            return {
                activeTab: false
            }
        },
        mounted() {
            this.activeTab = this.blockData.tabs[0]
        },
        methods: {

        },
    }
</script>
